<div
  *ngIf="data"
  class="label-with-tooltip-cell"
>
  <div
    class="label-with-tooltip-cell__label"
    qimaAutoTooltip
    [qimaAutoTooltipText]="data.value"
    [qimaAutoTooltipHasArrow]="true"
    [qimaAutoTooltipPosition]="qimaTooltip.position.TOP_LEFT"
    [qimaAutoTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaAutoTooltipStyle]="qimaTooltip.style.DARK"
  >
    {{ data.value }}
  </div>
  <div
    *ngIf="data.hoverSize > 0"
    class="label-with-tooltip-cell__amount"
    [qimaTooltipHasArrow]="true"
    [qimaTooltipPosition]="qimaTooltip.position.TOP"
    [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaTooltipStyle]="qimaTooltip.style.DARK"
    [qimaTooltipTemplate]="CardTooltip"
    qimaTooltip
  >
    +{{ data.hoverSize }}
  </div>
</div>

<ng-template #CardTooltip>
  <div
    *ngFor="let item of data.restText; let index = index"
    appNgForTrackByUuid
  >
    <ng-container>{{ item }}</ng-container>
  </div>
</ng-template>
